<template>
  <div class="protocol-page" @click="handleClick">
    <AppHead ref="head" :backFn="back"></AppHead>
    <div :class="[isMaxScreen ? 'pc_protocol-container' : 'protocol-container']">
      <div class="page-title">{{ pageTitle }}</div>

      <!-- 结构化数据：{ title, sections } -->
      <template v-if="isSectionData">
        <div
          v-for="(section, index) in content.sections"
          :key="index"
          class="paragraph"
        >
          <div v-if="section.title" class="title">{{ section.title }}</div>
          <div
            v-if="section.content"
            class="content"
            v-html="section.content"
          ></div>
          <div v-if="section.subsections">
            <div
              v-for="(subsection, subIndex) in section.subsections"
              :key="subIndex"
              class="subsection-block"
            >
              <div v-if="subsection.title" class="subtitle">{{ subsection.title }}</div>
              <div class="content" v-html="subsection.content"></div>
            </div>
          </div>
        </div>
      </template>

      <!-- HTML 字符串数据 -->
      <div v-else class="page-text-container" v-html="content"></div>
    </div>
    <Bottom ref="bottom"></Bottom>
  </div>
</template>

<script>
import { mapState } from 'vuex'

import Bottom from '@/components/bottom'
import AppHead from '@/components/head'

export default {
  name: 'ProtocolPage',
  components: {
    AppHead,
    Bottom
  },
  props: {
    title: {
      type: String,
      default: ''
    },
    content: {
      type: [String, Object],
      required: true
    }
  },
  computed: {
    ...mapState({
      isMaxScreen: state => state.isMaxScreen
    }),
    isSectionData() {
      return this.content && typeof this.content === 'object' && Array.isArray(this.content.sections)
    },
    pageTitle() {
      if (this.title) {
        return this.title
      }
      if (this.isSectionData && this.content.title) {
        return this.content.title
      }
      return ''
    }
  },
  mounted() {
    window.scrollTo(0, 0)
  },
  methods: {
    handleClick() {
      if (this.$refs.head && this.$refs.head.hidLangeList) {
        this.$refs.head.hidLangeList()
      }
    },
    back() {
      this.$router.push({ name: 'Home' })
    }
  }
}
</script>

<style scoped lang="less">
@media (min-width: 981px) {
  .protocol-page {
    width: 100%;
    min-height: 100%;
    background: #fff;
    font-family: "PingFang SC";
    .pc_protocol-container {
      padding: 160px 0 120px;
      width: 960px;
      margin: 0 auto;

      .page-title {
        color: #252629;
        text-align: center;
        font-size: 40px;
        font-weight: 500;
        line-height: 150%;
        margin-bottom: 36px;
        position: relative;
        padding-bottom: 16px;

        &::after {
          content: '';
          position: absolute;
          left: 50%;
          bottom: 0;
          width: 40px;
          height: 3px;
          margin-left: -20px;
          border-radius: 2px;
          background: #ff9600;
        }
      }

      .paragraph {
        margin-bottom: 44px;

        .title {
          color: #252629;
          font-size: 24px;
          font-weight: 500;
          line-height: 150%;
          margin-bottom: 18px;
        }

        .subtitle {
          color: #333;
          font-size: 18px;
          font-weight: 500;
          line-height: 150%;
          margin: 18px 0 10px;
        }

        .content {
          color: #666;
          font-size: 16px;
          font-weight: 400;
          line-height: 1.7;
        }
      }

      .subsection-block {
        margin-top: 16px;
      }

      /deep/.page-text-container {
        .paragraph {
          margin-bottom: 44px;

          .title {
            color: #252629;
            font-size: 24px;
            font-weight: 500;
            line-height: 150%;
            margin-bottom: 18px;
          }

          .text-box {
            .text {
              color: #666;
              font-size: 16px;
              font-weight: 400;
              line-height: 1.7;
              margin-bottom: 12px;
              .email {
                color: #165DFF;
                cursor: pointer;
              }
            }
          }
        }
      }

      /deep/.content {
        p {
          margin: 0 0 12px;
        }
        ul {
          margin: 0 0 12px;
          padding-left: 20px;
        }
        li {
          margin-bottom: 8px;
        }
        a {
          color: #165DFF;
        }
      }

      /deep/ table {
        margin: 16px 0;
        width: 100%;
        border-collapse: collapse;
        font-size: 14px;
        overflow: hidden;
        border: 1px solid #ebebeb;
        border-radius: 8px;
      }
      /deep/ th,
      /deep/ td {
        border: 1px solid #ebebeb;
        padding: 12px 14px;
        text-align: left;
        vertical-align: top;
      }
      /deep/ th {
        background: #fafafa;
        color: #333;
        font-weight: 500;
      }
    }
  }
}

@media (max-width: 980px) {
  .protocol-page {
    width: 100%;
    min-height: 100%;
    background: #fff;
    font-family: "PingFang SC";
    .protocol-container {
      padding: 148px 30px 48px;

      .page-title {
        color: #252629;
        text-align: center;
        font-size: 48px;
        font-weight: 500;
        line-height: 150%;
        margin-bottom: 48px;
        position: relative;
        padding-bottom: 20px;

        &::after {
          content: '';
          position: absolute;
          left: 50%;
          bottom: 0;
          width: 48px;
          height: 4px;
          margin-left: -24px;
          border-radius: 2px;
          background: #ff9600;
        }
      }

      .paragraph {
        margin-bottom: 48px;

        .title {
          color: #252629;
          font-size: 32px;
          font-weight: 500;
          line-height: 150%;
          margin-bottom: 28px;
        }

        .subtitle {
          color: #333;
          font-size: 28px;
          font-weight: 500;
          line-height: 150%;
          margin: 22px 0 14px;
        }

        .content {
          color: #666;
          font-size: 28px;
          font-weight: 400;
          line-height: 1.7;
          overflow-x: auto;
        }
      }

      .subsection-block {
        margin-top: 20px;
      }

      /deep/.page-text-container {
        width: 100%;
        .paragraph {
          margin-bottom: 48px;

          .title {
            color: #252629;
            font-size: 32px;
            font-weight: 500;
            line-height: 150%;
            margin-bottom: 28px;
          }

          .text-box {
            .text {
              color: #666;
              font-size: 28px;
              font-weight: 400;
              line-height: 1.7;
              margin-bottom: 14px;
              .email {
                color: #165DFF;
                cursor: pointer;
              }
            }
          }
        }
      }

      /deep/.content {
        p {
          margin: 0 0 16px;
        }
        ul {
          margin: 0 0 16px;
          padding-left: 28px;
        }
        li {
          margin-bottom: 10px;
        }
        a {
          color: #165DFF;
        }
      }

      /deep/ table {
        margin: 16px 0;
        width: 100%;
        border-collapse: collapse;
        font-size: 24px;
        border: 1px solid #ebebeb;
        border-radius: 8px;
        overflow: hidden;
      }
      /deep/ th,
      /deep/ td {
        border: 1px solid #ebebeb;
        padding: 12px;
        text-align: left;
        vertical-align: top;
      }
      /deep/ th {
        background: #fafafa;
        font-weight: 500;
      }
    }
  }
}
</style>
